import { Table } from '@mantine/core';
import type { UseQueryResult } from 'react-query';
import { DataTable } from '../../../components/DataTable';
import { Title } from '../../../components/Title';
import type { UsePaginationReturn } from '../../../hooks/usePagination';
import type { FilterDto } from '../../../util/types/FilterDto';
import type { ApiResponse } from '../../../util/types/Response';
import type { TotalAttendanceDto } from '../types/AttendanceDto';
import { GroupedAttendanceRow } from './GroupedAttendanceRow';
import { KeyedRow } from '../../../components/KeyedRow';

interface GroupedAttendanceProps {
	filter: FilterDto;
	attendanceCountQuery: UseQueryResult<ApiResponse<number>, unknown>;
	attendanceQuery: UseQueryResult<ApiResponse<TotalAttendanceDto[]>, unknown>;
	pagination: UsePaginationReturn;
	refreshTables: () => void;
}

export function GroupedAttendanceTable({
	filter,
	attendanceCountQuery,
	attendanceQuery,
	pagination,
	refreshTables,
}: GroupedAttendanceProps) {
	return (
		<>
			<DataTable
				pagination={pagination}
				totalItems={attendanceCountQuery.data?.value}
				isRowsLoading={attendanceQuery.isLoading}
				isPaginationLoading={attendanceCountQuery.isLoading}
				rows={pagination.value.pageSize}
				minHeight="66vh"
				maxHeight="76vh"
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th w={'15vw'}>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator Username'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Logon Count'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Total Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'View'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{attendanceQuery.data?.value.map((attendance) => (
						<GroupedAttendanceRow
							key={attendance.operatorId}
							totalAttendance={attendance}
							filter={filter}
							refreshTables={refreshTables}
						/>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
